<template>
  <div id="app" class="dolligo-wrap">
    <top-back-header-dolligo :propTitle="`프리미엄 멤버십 가입`"></top-back-header-dolligo>
    <div class="content-wrap">
      <div class="product-head">
        <h2>프리미엄 멤버십 {{ priceInfo[payType].payText }}</h2>
        <span class="discount">{{ priceInfo[payType].discountPercent }}%</span>
        <span class="og-price">{{ priceInfo[payType].price }}원</span>
        <span class="price-wrap">
          <span class="final-price">월 {{ priceInfo[payType].discountPrice }}원</span>
        </span>
      </div>
      <div class="premium-bottom">
        <div class="check-wrap">
          <label for="terms1" class="form-check-label">
            <input type="checkbox" id="terms1" class="form-check-input" v-model="datas.isAgree" :aria-invalid="termsAttempted && !datas.isAgree ? 'true' : 'false'" :aria-describedby="termsAttempted && !datas.isAgree ? 'terms-error' : null" />서비스 이용약관 동의 (필수)
            <span class="form-check-sign"><span class="check"></span></span>
          </label>
          <router-link :to="{ name: 'dolligoPremiumTerm' }" class="term-btn" @click.native="saveSession()">약관보기
          </router-link>
          <div v-if="termsAttempted && !datas.isAgree" id="terms-error" class="helper-txt error" role="alert">결제하려면 서비스 이용약관에 동의해 주세요.</div>
        </div>
        <button class="submit-btn p-on" :disabled="!datas.isAgree || paymentBusy || restoreBusy" @click="payStart()">{{ paymentBusy ? '결제 확인 중…' : '결제하기' }}</button>
        <div class="restore-help">
          <span>이미 결제하셨나요?</span>
          <button type="button" class="restore-link" :disabled="paymentBusy || restoreBusy" aria-describedby="restore-description" @click="purchaseHistoryCheck()">구매 복원</button>
        </div>
        <p id="restore-description" class="restore-description">결제했는데 프리미엄이 적용되지 않았다면 확인해 주세요.<br />추가 결제는 발생하지 않습니다.</p>
        <div class="checkout-status" role="status" aria-live="polite" aria-atomic="true">
          <div v-if="restoreBusy" class="restore-progress">
            <span class="restore-spinner" aria-hidden="true"></span>
            <div>
              <strong>구매 내역을 확인하고 있어요</strong>
              <p>스토어 확인에 시간이 걸릴 수 있어요. 잠시 기다려 주세요.</p>
            </div>
          </div>
          <p v-else-if="paymentNotice" class="payment-notice">{{ paymentNotice }}</p>
        </div>
      </div>

      <div class="noti-box-wrap">
        <h3>문의사항 및 해지/환불</h3>
        <ul>
          <li>문의사항은 <router-link :to="{ name: 'dolligoCommunity', params: { boardId: 'qa' } }">Q&amp;A
              게시판</router-link>에
            남겨주세요</li>
          <li>정기결제 이용 시 해지가 가능하며 만료일 이전에 해지하셔도 남은 일수만큼 환불되지 않습니다.(기존 이용권 만료일까지 프리미엄 멤버십 혜택 유지)</li>
          <li>월결제(3, 6개월) 이용시에는 환불이 불가능합니다.</li>
          <li>구글 정기구독(결제) 취소 : <strong>플레이스토어 &gt; 정기결제 &gt; 인사교류 &gt; 구독취소</strong></li>
          <li>애플 정기구독(결제) 취소 : <strong>App Store &gt; 프로필 이미지 클릭(계정) &gt; 구독 클릭 &gt; 구독 중인 항목 클릭 &gt; 하단 구독취소
              클릭</strong></li>
        </ul>
      </div>
    </div>
    <spinner ref="spinner"></spinner>
  </div>
</template>
<script>
import { newPaymentAttempt, paymentCancelled, notifyPayment } from '../../../services/paymentNotifications';
import axios from 'axios';
import { purchaseCandidates, appleRestoreReceipt } from '../../../services/purchasePayload';
import mixin from '../../../mixin';
import Spinner from '../../common/Spinner.vue';
import TopBackHeaderDolligo from '../../common/TopBackHeaderDolligo.vue';
export default {
  components: { Spinner, TopBackHeaderDolligo },
  mixins: [mixin],
  data: function () {
    return {
      payType: this.$route.query.payType,
      paymentNotice: '',
      paymentBusy: false,
      termsAttempted: false,
      restoreBusy: false,
      paymentAttempt: null,
      payMethod: '',
      purchaseHistoryMethod: '',
      swingPlugin: null,
      prodId: '',
      priceInfo: {
        12: { discountPercent: '29', price: '8,500', discountPrice: '6,000', iosProdId: 'premium_sub', andProdId: 'premium_subscribe', payText: '정기 결제' },
        14: { discountPercent: '41', price: '25,500', discountPrice: '15,000', iosProdId: 'premium3mth', andProdId: 'premium3month', payText: '3개월 결제' },
        15: { discountPercent: '47', price: '51,000', discountPrice: '27,000', iosProdId: 'premium6mth', andProdId: 'premium6month', payText: '6개월 결제' }
      },
      datas: {
        isAgree: false,
      }
    }
  },
  created: async function () {
    try {
      await this.getSession();
      this.swingPlugin = window.swingWebViewPlugin.app.inapp;
      this.payMethod = this.payType == '12' || this.isIphone == true ? 'subscribe' : 'buy';
      this.prodId = this.isIphone == true ? this.priceInfo[this.payType].iosProdId : this.priceInfo[this.payType].andProdId;
      this.purchaseHistoryMethod = this.isIphone == true ? 'getReceipt' : 'restorePurchases';
      // Restore only on explicit request; opening checkout must not lock purchasing.
    } catch (error) {
      this.errorHandler(error);
    }
  },
  methods: {
    paymentEvent(kind, reason = '', nativeCode = null) {
      try {
        if (!this.paymentAttempt) return;
        notifyPayment({ kind, reason, nativeCode, provider: this.isIphone ? 'apple' : 'google', productId: this.prodId,
          paymentAttempt: this.paymentAttempt }, this.axiosConfig);
      } catch (_) { /* Client notification failures must never affect purchases. */ }
    },
    async payStart() {
      if (this.paymentBusy || this.restoreBusy) return;
      this.termsAttempted = true;
      if (!this.datas.isAgree) return;
      if (!this.swingPlugin || typeof this.swingPlugin[this.payMethod] !== 'function') {
        this.paymentNotice = '앱 결제 기능을 사용할 수 없습니다. 앱을 다시 실행한 후 시도해 주세요.';
        return;
      }
      this.paymentBusy = true;
      this.paymentNotice = '';
      this.$refs.spinner.show = true;
      try { this.paymentAttempt = newPaymentAttempt(); } catch (_) { this.paymentAttempt = null; }
      this.paymentEvent('start');
      try {
        const response = await this.nativePurchase(this.payMethod, this.prodId);
        const success = this.isIphone ? 1 : 0;
        if (response.code !== success) {
          this.paymentEvent(paymentCancelled(this.isIphone ? 'apple' : 'google', response) ? 'cancelled' : 'failed', 'native', response.code);
          this.paymentNotice = '결제가 완료되지 않았습니다. 구매 내역을 확인해 주세요.';
          return;
        }
        await this.completePurchases(response.data);
      } catch (_) {
        this.paymentEvent('failed');
        this.paymentNotice = '결제 확인 중 문제가 발생했습니다. 다시 결제하지 말고 구매 내역을 확인해 주세요.';
      } finally {
        this.paymentBusy = false;
        this.paymentAttempt = null;
        this.$refs.spinner.show = false;
      }
    },
    nativePurchase(method, argument, timeoutMs = 120000) {
      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Purchase callback timeout')), timeoutMs);
        try {
          this.swingPlugin[method](argument, (code, data) => {
            clearTimeout(timer);
            const normalizedCode = typeof code === 'number' || (typeof code === 'string' && code.trim() !== '') ? Number(code) : NaN;
            resolve({ code: normalizedCode, data });
          });
        } catch (error) { clearTimeout(timer); reject(error); }
      });
    },
    async completePurchases(data, restoring = false) {
      const candidates = purchaseCandidates(this.isIphone ? 'apple' : 'google', data);
      if (!candidates.length) {
        if (!restoring) {
          this.paymentNotice = '아직 완료된 구매가 확인되지 않습니다. 결제 상태를 확인해 주세요.';
          this.paymentEvent('failed');
        }
        return false;
      }
      // Serial processing avoids competing callbacks and duplicate UI transitions.
      let completed = false;
      for (const candidate of candidates) {
        completed = (await this.payCompleted(candidate.productId, candidate.receipt)) || completed;
      }
      if (completed && !restoring && !this.paymentNotice) this.$router.push({ name: 'dolligoPremiumPayDone' });
      return completed;
    },
    async purchaseHistoryCheck() {
      if (this.paymentBusy || this.restoreBusy) return;
      this.restoreBusy = true;
      this.paymentNotice = '구매 내역을 확인하고 있습니다. 잠시 기다려 주세요.';
      let restored = false;
      try {
        if (!this.isIphone) {
          for (const kind of ['subs', 'inapp']) {
            const response = await this.nativePurchase('restorePurchases', kind, 30000);
            if (response.code !== 0) throw new Error('Restore failed');
            if (this.paymentNotice === '구매 내역을 확인하고 있습니다. 잠시 기다려 주세요.') this.paymentNotice = '';
            restored = (await this.completePurchases(response.data, true)) || restored;
          }
        } else {
          const receipt = await new Promise((resolve, reject) => {
            const timer = setTimeout(() => reject(new Error('Receipt callback timeout')), 30000);
            try { this.swingPlugin.getReceipt(value => { clearTimeout(timer); resolve(value); }); }
            catch (error) { clearTimeout(timer); reject(error); }
          });
          if (receipt) {
            // The server derives the product from the verified receipt, never the selected screen.
            const restoredReceipt = appleRestoreReceipt(receipt);
            if (!restoredReceipt) throw new Error('Invalid receipt callback');
            this.paymentNotice = '';
            restored = await this.payCompleted(null, restoredReceipt);
          }
        }
        if (this.paymentNotice === '구매 내역을 확인하고 있습니다. 잠시 기다려 주세요.') this.paymentNotice = '';
        if (restored && !this.paymentNotice) this.$router.push({ name: 'dolligoPremiumPayDone' });
        else if (!this.paymentNotice) this.paymentNotice = '복원할 유효한 구매 내역이 확인되지 않았습니다. 이미 결제했다면 고객센터에 문의해 주세요.';
      } catch (_) {
        this.paymentNotice = '구매 내역을 확인하지 못했어요.\n잠시 후 ‘구매 복원’을 다시 눌러 주세요.\n이미 결제했다면 추가 결제하지 마세요.';
      } finally { this.restoreBusy = false; }
    },
    async payCompleted(productId, receipt) {
      const path = this.isIphone ? 'apple' : 'google';
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const result = await axios.post(`/api/dolligo/payments-info/${path}`, {
            productId, receipt, mb_id: this.MEMBER.mb_id, paymentAttempt: this.paymentAttempt
          }, { ...this.axiosConfig, timeout: 60000 });
          if (result.data.processing === 'pending' || result.data.processing === 'review') {
            this.paymentNotice = result.data.message;
            return false;
          }
          return Boolean(result.data.member && result.data.member.mb_level == '5');
        } catch (error) {
          const status = error.response && error.response.status;
          if (attempt < 2 && (!status || status >= 500 || status === 429)) {
            await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(2, attempt)));
            continue;
          }
          this.paymentEvent('failed', 'transport');
          this.paymentNotice = '결제 확인을 완료하지 못했습니다. 다시 결제하지 말고 구매 내역을 복원하거나 고객센터에 문의해 주세요.';
          return false;
        }
      }
      return false;
    }
  }
}
</script>

<style scoped>
/* Keep the header offset inside this page instead of collapsing into body. */
.dolligo-wrap { display: flow-root; }
.dolligo-wrap .content-wrap { margin-bottom: 0; min-height: calc(100vh - 55px); min-height: calc(100dvh - 55px); display: flex; flex-direction: column; }
.dolligo-wrap .content-wrap > * { flex-shrink: 0; }
.dolligo-wrap .noti-box-wrap { flex-grow: 1; position: static; padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px)); }
.dolligo-wrap .submit-btn:disabled { background-color: #e0e0e0; color: #707070; cursor: not-allowed; opacity: 1; }
.payment-notice { margin: 16px 0 0; padding: 14px; border: 1px solid #ddd; border-radius: 8px; background: #fff; line-height: 1.6; font-size: 14px; white-space: pre-line; overflow-wrap: anywhere; }
.restore-help { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 4px; margin-top: 12px; font-size: 14px; line-height: 1.5; }
.restore-help > span { color: #666; }
.restore-link { min-height: 44px; padding: 8px; border: 0; background: transparent; color: #23854b; font: inherit; font-weight: 600; text-decoration: underline; text-underline-offset: 3px; cursor: pointer; }
.restore-link:focus-visible { outline: 2px solid #23854b; outline-offset: 2px; border-radius: 4px; }
.restore-description { margin: 0; text-align: center; font-size: 13px; line-height: 1.6; color: #666; }
.restore-progress { display: flex; align-items: flex-start; gap: 10px; margin-top: 16px; padding: 14px; border-radius: 8px; background: #fff; }
.restore-progress strong { font-size: 14px; line-height: 1.5; }
.restore-progress p { margin: 4px 0 0; color: #666; font-size: 13px; line-height: 1.6; }
.restore-spinner { flex: 0 0 18px; width: 18px; height: 18px; margin-top: 2px; border: 2px solid #dce7e0; border-top-color: #23854b; border-radius: 50%; animation: restore-spin .8s linear infinite; }
@keyframes restore-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .restore-spinner { animation: none; } }
button:disabled { cursor: wait; opacity: .6; }
</style>
